<template>
<div>
  <ul class="exchange-list vh100" v-if="prizeList.length">
    <li class="exchange-list-item"
        v-for="(item, index) in prizeList"
        @click="toPage(item)"
        :key="index">
      <h1>{{item.exchangeName}}</h1>
      <p>兑换日期:{{item.exchangeDate | dateFilter}}</p>
    </li>
  </ul>
  <div v-else class="exchange-list-null">
    <img src="./images/null.png" alt="">
  </div>
</div>

</template>

<script>
  import { format_filter } from '../../lib/dateUtils'
  export default {
  props: ['prizeList'],
  filters: {
    dateFilter: t => format_filter(t)('YYYY-MM-DD'),
  },
  methods: {
    toPage (item) {
      if (item.type === 1) {
        this.$router.push('/today')
      } else {
        this.$router.push('/vip')
      }
    }
  },
  beforeCreate () {

  },
  created () {
    this.$emit('getList')
  },
  beforeDestroy () {
  },
  components: {

  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.exchange-list {
  padding: 0 rem(30);
  &-item {
    padding: rem(30) 0;
    line-height: 1.2;
    border-bottom: rem(2) solid #EBEBEB;
    > h1 {
      font-size: rem(30);
      color: #333333;
      font-weight: bold;
      margin-bottom: rem(10);
    }
    > p {
      font-size: rem(26);
      color: #999999;
    }
  }
  &-null {
    padding-top: rem(251);
    text-align: center;
    > img {
      width: rem(537);
    }
  }
}
</style>
